import React from "react";
import PropTypes from "prop-types";
import Filter from "../../../../../models/Filter";
import { Toggle } from "../../../../../components/atoms";

function ToggleFilter({ filter, handleChange }) {
  const { value, label, id } = filter;

  const toggle = () => {
    handleChange({ ids: [id], value: value ? 0 : 1 });
  };

  return (
    <div className="tw-flex tw-my-1 tw-items-center">
      <Toggle isChecked={Boolean(value)} onChange={toggle} sizeClass="tw-w-7">
        <div className="tw-px-2">{label}</div>
      </Toggle>
    </div>
  );
}

ToggleFilter.propTypes = {
  handleChange: PropTypes.func.isRequired,
  filter: PropTypes.instanceOf(Filter).isRequired,
};

ToggleFilter.defaultProps = {};

export default ToggleFilter;
